module.exports = __webpack_public_path__ + "static/img/repair-improve.9bb346de.png";